import React from "react";
import HeaderInner from "../header/HeaderInner";
import AppoinmentB from "./breadcrumb/AppoinmentB";
import Footer from "../elements/Footer";
import Breadcrumb from "./Breadcrumb";

// DATA
import { DataNav } from "../data/DataNav";
import { DataRecrutement } from "../data/DataRecrutement";

function Appoinment() {
  const dataBreadcrumb = DataNav[4];

  return (
    <div className="service-details appoinment-inner-page">
      <div className="">
        <HeaderInner />
        <main>
          <Breadcrumb props={dataBreadcrumb} />

          {/* Start Contact Form Area  */}
          <div className="contact-area contact-bg-1 bg_image tmp-section-gap">
            <div className="container">
              <div>
                <div className="col-lg-12">
                  <div className="contact-inner">
                    <div className="section-head section-head-one-side text-align-left">
                      <h2 className="title">{DataRecrutement.sectionName}</h2>
                      <p className="description mt--30">
                        <em> {DataRecrutement.desc}</em>
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{ paddingTop: "120px" }}></div>

                <div className="col-lg-12 mt_md--50 mt_sm--50">
                  <div className="contact-form">
                    <div className="section-head section-head-one-side text-align-left">
                      <span className="subtitle">
                        {DataRecrutement.formSubtitle}
                      </span>
                      <h2 className="title">{DataRecrutement.formTitle}</h2>
                    </div>
                    <form id="contact-form" action="#">
                      <div className="contact-form-wrapper row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              name="contact-name"
                              placeholder="Nom & Prénom"
                              id="contact-name"
                              type="text"
                              required="votre nom est requis"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              name="contact-phone"
                              placeholder="Téléphone"
                              id="contact-phone"
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              name="contact-phone"
                              placeholder="Email"
                              type="email"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <input
                              className="input-field"
                              type="file"
                              id="contact-file"
                              placeholder="CV"
                              name="cv"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <textarea
                              className="input-field"
                              placeholder="Collecter votre lettre de motivation ici"
                              name="contact-message"
                              id="contact-message"
                              required="la lettre de motivation est requise"
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-submit-group">
                            <button
                              name="submit"
                              className="tmp-btn btn-primary"
                              type="submit"
                              id="submit"
                            >
                              <span className="submit-wrapper">
                                <span className="btn-text">
                                  Postuler Maintenant
                                </span>
                                <span className="btn-icon">
                                  <i className="fa-sharp fa-light fa-arrow-right" />
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Start Contact Form Area  */}
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default Appoinment;
